"use client";

import { FC } from "react";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { motion } from "framer-motion";

/**
 * Props for `LetsConnectSection`.
 */
export type LetsConnectSectionProps =
  SliceComponentProps<Content.LetsConnectSectionSlice>;

/**
 * Component for "LetsConnectSection" Slices.
 */
const LetsConnectSection: FC<LetsConnectSectionProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white py-[60px] px-4 md:px-[30px] lg:px-[60px] xl:px-20 flex flex-col items-center justify-center gap-4"
    >
      <div className="p-3.5 bg-[#D9F0FF] rounded-[40px] flex items-center justify-center gap-2.5">
        <PrismicNextImage field={slice.primary.badge_icon} />
        <span>{slice.primary.badge_content}</span>
      </div>
      <motion.div
        className="font-archivo text-[#033D61] text-4xl font-bold leading-12 md:text-5xl md:font-semibold md:leading-16"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <PrismicRichText
          field={slice.primary.title}
          components={{
            label: ({ node, children }) => {
              if (node.data.label === "Highlight") {
                return <span className="text-secondary">{children}</span>;
              }
              return <span className="text-primary">{children}</span>;
            },
          }}
        />
      </motion.div>
      <motion.div
        className="text-center text-[#033D61] font-archivo md:font-merriweather text-base font-normal md:leading-8 md:text-xl leading-6"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <PrismicRichText
          field={slice.primary.sub_title}
          components={{
            label: ({ node, children }) => {
              if (node.data.label === "Highlight") {
                return <span className="text-secondary">{children}</span>;
              }
              return <span className="text-primary">{children}</span>;
            },
          }}
        />
      </motion.div>
    </section>
  );
};

export default LetsConnectSection;
